import {
  getIncompatibleInverterIds,
  type ModuleInverterCompatibilityData,
} from "@logic/lib/powur-os"

export type InverterForCompatibility = {
  id: number
  name: string
}

export const getCompatibleInverters = <T extends { id: number }>(
  moduleData: ModuleInverterCompatibilityData | null | undefined,
  inverters: T[],
): T[] => {
  const incompatibleInverterIds = getIncompatibleInverterIds(moduleData)

  return inverters.filter(({ id }) => !incompatibleInverterIds.has(id))
}

export const getIncompatibleSelectedInverters = (
  moduleData: ModuleInverterCompatibilityData | null | undefined,
  inverters: Array<InverterForCompatibility | null | undefined>,
  currentInverterIds?: ReadonlySet<number>,
): InverterForCompatibility[] => {
  const incompatibleInverterIds = getIncompatibleInverterIds(moduleData)
  const seenInverterIds = new Set<number>()

  return inverters.filter((inverter): inverter is InverterForCompatibility => {
    if (
      !inverter ||
      seenInverterIds.has(inverter.id) ||
      (currentInverterIds !== undefined &&
        !currentInverterIds.has(inverter.id)) ||
      !incompatibleInverterIds.has(inverter.id)
    ) {
      return false
    }

    seenInverterIds.add(inverter.id)
    return true
  })
}
